<template>
  <div class="ml18-ponto-eletronico">
    <PageTitle
      icon="fa fa-calendar"
      main="Ponto eletrônico"
      sub="Ficha ponto"
    />
    <div class="ponto-eletronico2">
      <b-card no-body>
        <b-tabs>
          <b-tab title="AFD exportar arquivo" active
            ><PontoLancamentosAfd
          /></b-tab>
          <b-tab title="ML18-Consulta Ficha ponto operador "
            ><PonConsultaFichaPonto
          /></b-tab>
          <b-tab title="Horas Programado x Realizado"
            ><PonProgramadoRealizado
          /></b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import PageTitle from "../template/PageTitle";
import PonConsultaFichaPonto from "../ml18_frq_pontoeletronico/PonConsultaFichaPonto";
import PontoLancamentosAfd from "../ml18_frq_pontoeletronico/PontoLancamentosAfd";
import PonProgramadoRealizado from "../ml18_frq_pontoeletronico/PonProgramadoRealizado";
export default {
  name: "Ml18PontoEletronicoPrincipal",
  components: {
    PageTitle,
    PonConsultaFichaPonto,
    PontoLancamentosAfd,
    PonProgramadoRealizado,
  },
};
</script>

<style>
</style> 
